import { inject } from 'inversify-props';
import { IStorage } from '../../services';
import { SearchRequest } from '../common/SearchRequest';
import { Company } from '../industry/Company';
import { Season } from '../common/Season';

export class SeriesSearchRequest extends SearchRequest {

	@inject('IStorage')
	public storage: IStorage;

	public companyIds: string[] = [];
	public companies: Company[] = [];
	public seasons: Season[] = [];
	public seasonIds: number[] = [];
	public startYear?: number;
	public endYear?: number;
	public isEnabled?: boolean = null;

	constructor(init?: any) {
		super(init);
		if (!init) { return; }
		if (init.companyIds) { 
			if (Array.isArray(init.companyIds)) {
				this.companyIds = init.companyIds;
			} else {
				this.companyIds = init.companyIds.split(','); 
			}
		}
		if (init.seasonIds) {
			if (Array.isArray(init.seasonIds)) {
				this.seasonIds = init.seasonIds;
			} else {
				const seasons = init.seasonIds.split(',');
				this.seasonIds = seasons.map((x) => parseInt(x, null));
			}
		}
		if (init.startYear) { this.startYear = parseInt(init.startYear, null); }
		if (init.endYear) { this.endYear = parseInt(init.endYear, null); }
		if (init.isEnabled != null) { this.isEnabled = (init.isEnabled.toString() === 'true'); }

		// INSTEAD OF GETTING THESE VALUES FROM THE DATABASE, TRY AND GET THEM FROM LOCAL STORAGE
		const json = this.storage.retrieve('series-filter');
		if (!json) { return; }

		const prevFilter = JSON.parse(json) as SeriesSearchRequest;
		if (!prevFilter) { return; }

		// RESTORE COMPANIES FROM IN MEMORY SEARCH REQUEST
		if (prevFilter?.companies?.length) {
			for (const id of this.companyIds) {
				const found = prevFilter.companies.find((x) => x.id === id);
				if (found) { this.companies.push(found); }
			}
		}

		// RESTORE SEASONS FROM IN MEMORY SEARCH REQUEST
		if (prevFilter?.seasons?.length) {
			for (const id of this.seasonIds) {
				const found = prevFilter.seasons.find((x) => x.id === id);
				if (found) { this.seasons.push(found); }
			}
		}
	}

	/** Collapses the values in this search request object so they can be persisted to a query string */
	public collapse(): any {
		const response: { [k: string]: any } = super.collapse();
		if (this.companyIds && this.companyIds.length) { response.companyIds = this.companyIds.join(','); }
		if (this.seasonIds && this.seasonIds.length) { response.seasonIds = this.seasonIds.join(','); }
		if (this.startYear) { response.startYear = this.startYear; }
		if (this.endYear) { response.endYear = this.endYear; }
		if (this.isEnabled != null) { response.isEnabled = this.isEnabled; }
		return response;
	}

	/** Clears the values in this search request object */
	public clear() {
		super.clear();
		this.seasonIds = [];
		this.seasons = [];
		this.companyIds = [];
		this.companies = [];
		this.isEnabled = null;
	}

}
